import ButtonText from "./buttonText";

export default ButtonText;